(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    function initPremiumHeader() {
      var wrapper = document.querySelector('.header-wrapper');
      if (!wrapper) return;

      function onScroll() {
        if (window.scrollY > 20) {
          wrapper.classList.add('header-scrolled');
        } else {
          wrapper.classList.remove('header-scrolled');
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      /* Order Now button removed */
    }

    /* ── Rewrite mobile drawer links ── */
    function updateDrawerLinks() {
      var customLinks = [
        { title: 'Home',         url: '/' },
        { title: 'The Scale',    url: '/collections/all' },
        { title: 'How It Works', url: '/#omeal-how' },
        { title: 'About Us',     url: '/pages/about-us' },
        { title: 'Contact',      url: '/pages/contact' }
      ];
      var drawerNav = document.querySelector('.menu-drawer__navigation .list-menu');
      if (!drawerNav) return;
      drawerNav.innerHTML = '';
      customLinks.forEach(function(link) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = link.url;
        a.className = 'menu-drawer__menu-item list-menu__item list-menu__item--link link link--text focus-inset';
        a.textContent = link.title;
        li.appendChild(a);
        drawerNav.appendChild(li);
      });

    }

    /* Run immediately and also when drawer opens */
    updateDrawerLinks();
    document.addEventListener('click', function(e) {
      if (e.target.closest('header-drawer, .menu-drawer-container')) {
        setTimeout(updateDrawerLinks, 50);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPremiumHeader);
    } else {
      initPremiumHeader();
    }
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omeal-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  var mainImg = document.querySelector('.omeal-col__img');
  var thumbs = document.querySelectorAll('.omeal-col__thumb');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (mainImg) {
        var src = this.getAttribute('data-src');
        mainImg.src = src;
        mainImg.srcset = src;
        mainImg.removeAttribute('srcset');
      }
      thumbs.forEach(function(t) { t.classList.remove('omeal-col__thumb--active'); });
      this.classList.add('omeal-col__thumb--active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omeal-product-showcase"] && !Shopify.designMode) return;
  try {
    
(function() {
  var mainImg = document.querySelector('.omeal-col__img');
  var thumbs = document.querySelectorAll('.omeal-col__thumb');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = this.getAttribute('data-src'); }
      thumbs.forEach(function(t) { t.classList.remove('omeal-col__thumb--active'); });
      this.classList.add('omeal-col__thumb--active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omeal-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.getElementById('omeal-satc');
  if (!bar) return;
  var mainBtn = document.querySelector('.omeal-col__btn-cart');
  if (!mainBtn) return;

  function check() {
    var rect = mainBtn.getBoundingClientRect();
    var past = rect.bottom < 0;
    if (past) {
      bar.classList.add('omeal-satc--visible');
      bar.setAttribute('aria-hidden', 'false');
    } else {
      bar.classList.remove('omeal-satc--visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  }
  window.addEventListener('scroll', check, { passive: true });
  check();
})();

  } catch(e) { console.error(e); }
})();
})();
